import React, { Component, useState } from 'react';
import { Icon, Dropdown, Button, Modal } from 'semantic-ui-react';
import './styles.css';

export default function ModalAdicionarCurso(props) {
    const { cursos } = props;
    const [open, setOpen] = useState(false);
    
    return(
        <Modal trigger = {
            <Button id="painel-carrosseis_adicionar-curso" primary>
                <Icon name="add" /> Adicionar Curso
            </Button>
        }
        open={open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        >
            <Modal.Header>Adição de curso</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    <Dropdown
                        id="painel-carrosseis_cursos-dropdown"
                        name="cursos-dropdown"
                        placeholder='Cursos'
                        search
                        fluid
                        multiple
                        selection
                        options = { cursos.options }
                        onChange = {props.handleCursosDropdownChange}
                        value = { cursos.dropdown.value || 0  }
                    />

                    <Button onClick={() => {props.addCurso(); setOpen(false)}} id="painel-carrosseis_adicionar-curso" primary>
                        <Icon name="add" /> Adicionar
                    </Button>
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}